import { render } from "./TableView.vue?vue&type=template&id=248553b9&scoped=true"
import script from "./TableView.vue?vue&type=script&lang=js"
export * from "./TableView.vue?vue&type=script&lang=js"

import "./TableView.vue?vue&type=style&index=0&id=248553b9&scoped=true&lang=css"

import exportComponent from "/build/cloudstack/dist/rpmbuild/BUILD/cloudstack-4.22.1.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-248553b9"]])

export default __exports__